export default __webpack_public_path__ + "images/6b65264270227b129d576c3b331d8fa8-opera.jpg";